import { DeliveryChargeRuleScope, IDeliveryChargeRule } from "./interfaces";

export const displayDeliveryRule = (r: IDeliveryChargeRule): string => {
    if (r.scope == DeliveryChargeRuleScope.AREA) 
        return r.area!.name_en

        if (r.scope == DeliveryChargeRuleScope.GOVERNORATE) 
            return `Governorate: ${r.governorate ?? 'ERROR'}`

        if (r.scope == DeliveryChargeRuleScope.DISTRICT) 
            return `District: ${r.district ?? 'ERROR'}`

        return 'ERROR'
}